// Pending Matches (PD-13891) filters — Search / State / Type(source).
// These render the filter tray on the consolidated match-review list
// (listKey 'license_match'). The backend handler is the custom
// GET /api/licenses/matches/list endpoint, which reads these query params from
// the filters JSON (matchKeywords / matchState / matchSource), so no shared
// queryMapping is needed here.

import { createKeywordFilter } from './factories';
import type { FilterRegistry } from './types';

export const licenseMatchFilters: FilterRegistry = {
	matchKeywords: {
		...createKeywordFilter({
			label: 'Search',
			placeholder: 'Search matches...',
			objectTable: 'client_license_match',
			listKeys: ['license_match'],
		}),
		queryParamName: 'matchKeywords',
	},

	matchState: {
		type: 'multi-select',
		label: 'State',
		placeholder: 'Select state...',
		colorScheme: 'green',
		searchable: true,
		loadOnFocus: true,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		apiEndpoint: '/licenses/state/options',
		queryParamName: 'matchState',
		multiple: true,
		valueExtractor: {
			property: 'id',
		},
		format: 'array',
		listKeys: ['license_match'],
	},

	matchSource: {
		type: 'multi-select',
		label: 'Type',
		placeholder: 'Select type...',
		colorScheme: 'purple',
		searchable: false,
		loadOnFocus: false,
		displayFields: {
			id: 'id' as keyof unknown,
			primary: 'label' as keyof unknown,
		},
		queryParamName: 'matchSource',
		multiple: true,
		valueExtractor: {
			property: 'id',
		},
		// Normalized registry source classifications (lm_registry.source_type),
		// denormalized onto client_license_match.registry_source_type.
		options: [
			{ id: 'STATE_BOARD', label: 'State Board' },
			{ id: 'DEA', label: 'DEA' },
			{ id: 'NPI', label: 'NPI' },
			{ id: 'CONTROLLED_SUBSTANCE', label: 'Controlled Substance' },
			{ id: 'TOBACCO', label: 'Tobacco' },
			{ id: 'LIQUOR', label: 'Liquor' },
			{ id: 'KYC', label: 'KYC' },
			{ id: 'OTHER', label: 'Other' },
		],
		format: 'array',
		listKeys: ['license_match'],
	},
};
